import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const resetPassword = async ({ username, newPassword, tokenOrTempPassword }) => {
  const PASSWORD_MAX_LENGTH = 20;

  if (newPassword && newPassword.length > PASSWORD_MAX_LENGTH) {
    toast.error(`Password cannot exceed ${PASSWORD_MAX_LENGTH} characters.`);
    return null;
  }

  try {
    const response = await axios.post(`${API_BASE_URL}/reset-password`, {
      username,
      newPassword,
      tokenOrTempPassword,
    });

    if (response.data.success) {
      // toast.success("Password reset successfully");
      return response.data;
    } else {
      toast.error(response.data.message || "Failed to reset password.");
      return null;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to reset password. Please try again.");
    return null;
  }
};

export const generateTempPassword = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/generate-temp-password`, {
      username: email,
    });
    return response.data; 
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Something went wrong.",
    };
  }
};
